export const DOMAIN = 'sellingRateCalendarPage';

export const RESET_STATE = 'app/SellingRateCalendarPage/RESET_STATE';
export const FETCH_RATES = 'app/SellingRateCalendarPage/FETCH_RATES';
export const FETCH_RATES_START = 'app/SellingRateCalendarPage/FETCH_RATES_START';
export const FETCH_RATES_SUCCESS = 'app/SellingRateCalendarPage/FETCH_RATES_SUCCESS';
export const FETCH_RATES_ERROR = 'app/SellingRateCalendarPage/FETCH_RATES_ERROR';
export const FETCH_RATES_CANCEL = 'app/SellingRateCalendarPage/FETCH_RATES_CANCEL';

export const UPDATE_RATE = 'app/SellingRateCalendarPage/UPDATE_RATE';
export const UPDATE_RATE_START = 'app/SellingRateCalendarPage/UPDATE_RATE_START';
export const UPDATE_RATE_SUCCESS = 'app/SellingRateCalendarPage/UPDATE_RATE_SUCCESS';
export const UPDATE_RATE_ERROR = 'app/SellingRateCalendarPage/UPDATE_RATE_ERROR';
export const RESET_UPDATE_STATE = 'app/SellingRateCalendarPage/RESET_UPDATE_STATE';
export const REMOVE_UPDATE_ERROR = 'app/SellingRateCalendarPage/REMOVE_UPDATE_ERROR';
